import React from 'react'
import * as api from 'requests'

const appSettingCache = {}
export const useAppSetting = (name, { cache } = {}) => {
  const [setting, setSetting] = React.useState(null)
  const [error, setError] = React.useState(false)
  const [loading, setLoading] = React.useState(true)
  const isPending = React.useRef(false)

  React.useEffect(() => {
    if (!isPending.current) {
      if (cache ? !appSettingCache[name] : true) {
        isPending.current = true
        setError(false)
        setSetting(null)
        setLoading(true)
        api.GET_APP_SETTING_BY_NAME(
          name,
          (setting) => {
            if (setting) {
              appSettingCache[name] = setting
              isPending.current = false
              setSetting(setting)
              setLoading(false)
            }
          },
          (err) => {
            console.error(err)
            setError(err)
            setLoading(false)
          }
        )
      } else {
        setLoading(false)
        setError(false)
        setSetting(appSettingCache[name])
      }
    }
  }, [name])

  return {
    loading,
    error,
    setting,
  }
}

export const useList = (initial) => {
  const [list, setList] = React.useState(() => {
    if (Array.isArray(initial)) {
      return initial
    } else {
      throw new Error('The initial value for useList must be an array.')
    }
  })

  const push = (item) => {
    setList((l) => [...l, item])
  }

  const pop = (item) => {
    setList((l) => [item, ...l])
  }

  const addAtIndex = (item, index) => {
    setList((l) => [...l.slice(0, index), item, ...l.slice(index)])
  }

  const removeAtIndex = (index) => {
    setList((l) => [...l.slice(0, index), ...l.slice(index + 1)])
  }

  const replaceAtIndex = (item, index) => {
    setList((l) => [...l.slice(0, index), item, ...l.slice(index + 1)])
  }

  return [list, { push, pop, removeAtIndex, addAtIndex, replaceAtIndex }]
}

export const usePrevious = (value) => {
  const ref = React.useRef()

  React.useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}



// WEBPACK FOOTER //
// ./src/Utilities/hooks.js